function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useRef, useState } from 'react';
import { classNames } from '../../../../utilities/css.js';
import styles from '../../ActionList.scss.js';
import { handleMouseUpByBlurring } from '../../../../utilities/focus.js';
import { useIsomorphicLayoutEffect } from '../../../../utilities/use-isomorphic-layout-effect.js';
import { useTheme } from '../../../../utilities/use-theme.js';
import { Badge } from '../../../Badge/Badge.js';
import { Tooltip } from '../../../Tooltip/Tooltip.js';
import { Icon } from '../../../Icon/Icon.js';
import { Box } from '../../../Box/Box.js';
import { Text } from '../../../Text/Text.js';
import { Scrollable } from '../../../Scrollable/Scrollable.js';
import { UnstyledLink } from '../../../UnstyledLink/UnstyledLink.js';
import { InlineStack } from '../../../InlineStack/InlineStack.js';
function Item(_ref) {
  var id = _ref.id,
    badge = _ref.badge,
    content = _ref.content,
    accessibilityLabel = _ref.accessibilityLabel,
    helpText = _ref.helpText,
    url = _ref.url,
    onAction = _ref.onAction,
    onMouseEnter = _ref.onMouseEnter,
    icon = _ref.icon,
    image = _ref.image,
    prefix = _ref.prefix,
    suffix = _ref.suffix,
    disabled = _ref.disabled,
    external = _ref.external,
    destructive = _ref.destructive,
    ellipsis = _ref.ellipsis,
    truncate = _ref.truncate,
    active = _ref.active,
    role = _ref.role,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'default' : _ref$variant;
  var className = classNames(styles.Item, disabled && styles.disabled, destructive && styles.destructive, active && styles.active, variant === 'default' && styles.default, variant === 'indented' && styles.indented, variant === 'menu' && styles.menu);
  var prefixMarkup = null;
  if (prefix) {
    prefixMarkup = /*#__PURE__*/React.createElement("span", {
      className: styles.Prefix
    }, prefix);
  } else if (icon) {
    prefixMarkup = /*#__PURE__*/React.createElement("span", {
      className: styles.Prefix
    }, /*#__PURE__*/React.createElement(Icon, {
      source: icon
    }));
  } else if (image) {
    prefixMarkup = /*#__PURE__*/React.createElement("span", {
      role: "presentation",
      className: styles.Prefix,
      style: {
        backgroundImage: "url(".concat(image)
      }
    });
  }
  var contentText = content || '';
  if (truncate && content) {
    contentText = /*#__PURE__*/React.createElement(TruncateText, null, content);
  } else if (ellipsis) {
    contentText = "".concat(content, "\u2026");
  }
  var contentMarkup = helpText ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Box, null, contentText), /*#__PURE__*/React.createElement(Text, {
    as: "span",
    variant: "bodySm",
    tone: active || disabled ? undefined : 'subdued'
  }, helpText)) : contentText;
  var badgeMarkup = badge && /*#__PURE__*/React.createElement("span", {
    className: styles.Suffix
  }, /*#__PURE__*/React.createElement(Badge, {
    tone: badge.tone
  }, badge.content));
  var suffixMarkup = suffix && /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement("span", {
    className: styles.Suffix
  }, suffix));
  var textMarkup = /*#__PURE__*/React.createElement("span", {
    className: styles.Text
  }, contentMarkup);
  var contentElement = /*#__PURE__*/React.createElement(InlineStack, {
    blockAlign: "center",
    gap: "150",
    wrap: false
  }, prefixMarkup, textMarkup, badgeMarkup, suffixMarkup);
  var contentWrapper = /*#__PURE__*/React.createElement(Box, {
    width: "100%"
  }, contentElement);
  var scrollMarkup = active ? /*#__PURE__*/React.createElement(Scrollable.ScrollTo, null) : null;
  var control = url ? /*#__PURE__*/React.createElement(UnstyledLink, {
    id: id,
    url: disabled ? null : url,
    className: className,
    external: external,
    "aria-label": accessibilityLabel,
    onClick: disabled ? null : onAction,
    role: role
  }, contentWrapper) : /*#__PURE__*/React.createElement("button", {
    id: id,
    type: "button",
    className: className,
    disabled: disabled,
    "aria-label": accessibilityLabel,
    onClick: onAction,
    onMouseUp: handleMouseUpByBlurring,
    role: role,
    onMouseEnter: onMouseEnter
  }, contentWrapper);
  return /*#__PURE__*/React.createElement(React.Fragment, null, scrollMarkup, control);
}
var TruncateText = function TruncateText(_ref2) {
  var children = _ref2.children;
  var theme = useTheme();
  var textRef = useRef(null);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOverflowing = _useState2[0],
    setIsOverflowing = _useState2[1];
  useIsomorphicLayoutEffect(function () {
    if (textRef.current) {
      setIsOverflowing(textRef.current.scrollWidth > textRef.current.offsetWidth);
    }
  }, [children]);
  var text = /*#__PURE__*/React.createElement(Text, {
    as: "span",
    truncate: true
  }, /*#__PURE__*/React.createElement(Box, {
    width: "100%",
    ref: textRef
  }, children));
  return isOverflowing ? /*#__PURE__*/React.createElement(Tooltip, {
    zIndexOverride: Number(theme.zIndex['z-index-11']),
    preferredPosition: "above",
    hoverDelay: 1000,
    content: children,
    dismissOnMouseOut: true
  }, /*#__PURE__*/React.createElement(Text, {
    as: "span",
    truncate: true
  }, children)) : text;
};
export { Item, TruncateText };